<template>
    <main class="public-page-prerender" data-prerender-kind="public-page">
        <p class="public-page-prerender__eyebrow">Sejarah Thümann</p>
        <h1>{{ title }}</h1>
        <p class="public-page-prerender__description">{{ description }}</p>
    </main>
</template>

<script>
import { applyGenericSeo } from '@/utils/seoUtils';

const pageSeo = {
    '/': { title: 'home.seoTitle', description: 'home.seoDescription', completeTitle: true },
    '/nieuw': { title: 'recentChanges.seoTitle', description: 'recentChanges.seoDescription', completeTitle: true },
    '/gezocht': { title: 'researchPage.seoTitle', description: 'researchPage.seoDescription', completeTitle: true },
    '/over': { title: 'aboutPage.seoTitle', description: 'aboutPage.seoDescription', completeTitle: true },
    '/contact': { title: 'contactPage.seoTitle', description: 'contactPage.seoDescription', completeTitle: true },
    '/fotos-en-documenten': { title: 'mediaOverview.seoTitle', description: 'mediaOverview.seoDescription', completeTitle: true },
    '/dna': { title: 'geneticMatches.title', description: 'geneticMatches.seoDescription' },
    '/kalender': { title: 'eventCalendar.title', description: 'eventCalendar.subtitle' },
    '/statistieken': { title: 'siteStatsOverview.seoTitle', description: 'siteStatsOverview.seoDescription', completeTitle: true },
    '/statistieken/groei': { title: 'siteStatsGrowth.seoTitle', description: 'siteStatsGrowth.seoDescription', completeTitle: true },
    '/stamboom': { title: 'stamboom.seoTitle', description: 'stamboom.seoDescription', completeTitle: true },
    '/verhalen': { title: 'nav.stories', description: 'blogOverview.subtitle' },
};

export default {
    name: 'PublicPagePrerenderSnapshot',
    computed: {
        locale() {
            return this.$route.params.locale || 'nl';
        },
        canonicalRoute() {
            const withoutLocale = this.$route.path.replace(/^\/(?:nl|en|id)(?=\/|$)/, '');
            return withoutLocale || '/';
        },
        config() {
            return pageSeo[this.canonicalRoute] || null;
        },
        title() {
            if (!this.config) return 'Sejarah Thümann';
            const translated = this.$t(this.config.title);
            return this.config.completeTitle ? translated.replace(/\s*\|\s*Sejarah Thümann$/, '') : translated;
        },
        description() {
            return this.config ? this.$t(this.config.description) : '';
        },
        seoTitle() {
            if (!this.config) return 'Sejarah Thümann';
            return this.config.completeTitle ? this.$t(this.config.title) : `${this.title} | Sejarah Thümann`;
        },
    },
    mounted() {
        if (!this.config) {
            document.dispatchEvent(new Event('sejarah-prerender-ready'));
            return;
        }

        document.documentElement.lang = this.locale;
        applyGenericSeo({
            title: this.seoTitle,
            description: this.description,
            image: 'https://sejarah-thumann.online/img/sejarah_thumann1080x781.4fc54a6a.jpg',
            currentLocale: this.locale,
            route: this.canonicalRoute,
        }, {
            includeTwitter: true,
            includeHreflangs: true,
        });

        this.$nextTick(() => {
            document.dispatchEvent(new Event('sejarah-prerender-ready'));
        });
    },
};
</script>

<style scoped>
.public-page-prerender {
    max-width: 760px;
    margin: 0 auto;
    padding: 96px 24px;
    color: #242424;
    font-family: Arial, sans-serif;
    line-height: 1.65;
}

.public-page-prerender__eyebrow {
    margin: 0 0 8px;
    color: #8c1d24;
    font-weight: 700;
}

.public-page-prerender h1 {
    margin: 0;
    font-size: 2.5rem;
}

.public-page-prerender__description {
    margin: 24px 0 0;
    font-size: 1.125rem;
}
</style>
